/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableRow` component.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('TableFoot', {
  root: css`
    display: table-footer-group;
  `,
});

/**
 * The `tfoot` tag; use to summarize data.
 */
export const TableFoot = (props: Props) => {
  return <tfoot css={Styles.root}>{props.children}</tfoot>;
};
